'use client';

import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {useClpNoticeContext} from '@/features/course-landing-page/context/clp-notice-context-provider.react-component';
import {
    PlanPeriodStyle,
    SubscriptionCTA,
    SubscribeFromPageCookie,
} from '@udemy-v2/react-subscription-browse';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import styles from './subscription-sticky-footer-cta.module.scss';

export const SubscriptionStickyFooterCta = () => {
    const {unwrappedConsumerSubscriptionPlan, subscriptionCTAConfiguration} =
        useClpPurchaseContext();
    const clpNoticeContext = useClpNoticeContext();
    const course = useClpCourse();
    const subscriptionPriceBoxNotice = clpNoticeContext?.subscriptionPriceBoxNoticeData;

    const handleCtaClick = () => {
        SubscribeFromPageCookie.set('course_landing_page', parseInt(course.id, 10));
    };

    if (!unwrappedConsumerSubscriptionPlan) {
        return null;
    }

    return (
        <div data-testid="subscription-sticky-footer" data-purpose="subscription-sticky-footer">
            <SubscriptionCTA
                className={styles['subscription-cta']}
                uiRegion="subscription_sticky_footer"
                subtitleClassName={styles['cta-subtitle']}
                data-purpose="subscription-sticky-footer-button"
                offerCtaStyle="primary"
                onCTAClick={handleCtaClick}
                courseId={parseInt(course.id, 10)}
                includeTrialDaysOnCta={false}
                plan={unwrappedConsumerSubscriptionPlan}
                noticeData={subscriptionPriceBoxNotice}
                planPeriodStyle={PlanPeriodStyle.SINGLE}
                directCheckout={subscriptionCTAConfiguration?.directCheckout}
                selectPlanText={subscriptionCTAConfiguration?.selectPlanText}
                purchaseCtaText={subscriptionCTAConfiguration?.purchaseCtaText}
            />
        </div>
    );
};
